import { render, staticRenderFns } from "./PrestacaoDeConta.vue?vue&type=template&id=7a825751"
import script from "./PrestacaoDeConta.vue?vue&type=script&lang=js"
export * from "./PrestacaoDeConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports